/**
 * This global module so all pipe can be used in every pages
 */

import { NgModule } from '@angular/core';
import { DatePipe } from './date.pipe';
import { LetterPipe } from './letter.pipe';
import { DecodeHtmlStringPipe } from './decode-html-string.pipe';
import { PluralizerPipe } from './pluralizer.pipe';

@NgModule({
declarations: [DatePipe, LetterPipe, DecodeHtmlStringPipe, PluralizerPipe],
imports: [],
exports: [DatePipe, LetterPipe, DecodeHtmlStringPipe, PluralizerPipe],
})

export class PipesModule {}
